export default function ProductsHero() {
  return (
    <section className="relative bg-background-50 pt-32 md:pt-40 pb-16 md:pb-24 overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://readdy.ai/api/search-image?query=Abstract%20light%20industrial%20petroleum%20refinery%20silhouette%20with%20soft%20warm%20tones%2C%20chemical%20processing%20plant%20atmosphere%2C%20bright%20clean%20sky%20with%20subtle%20clouds%2C%20cinematic%20industrial%20background%2C%20soft%20ambient%20lighting%2C%20light%20tones%20with%20warm%20golden%20highlights&width=1600&height=900&seq=products-hero-bg-light&orientation=landscape')] bg-cover bg-center opacity-8" />
      <div className="absolute inset-0 bg-gradient-to-b from-background-100/60 via-background-50/80 to-background-50" />

      <div className="relative w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-6">
            <i className="ri-stack-line text-sm w-4 h-4 flex items-center justify-center" />
            Producto Importado
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 mb-5">
            Demulsificante Importado de <span className="text-primary-500">Rixin Corp, China</span>
          </h1>
          <p className="text-foreground-600 text-sm md:text-lg max-w-3xl mx-auto mb-8">
            Demulsificante ya formulado por Rixin Corp, importado directamente a Venezuela. 
            Aprobado en laboratorios de PDVSA y listo para entrega inmediata a sus campos petroleros.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#presentaciones"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#presentaciones')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Ver Presentaciones
              <i className="ri-arrow-down-line" />
            </a>
            <a
              href="#revendedores"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#revendedores')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-background-300 text-foreground-600 font-semibold text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Programa de Revendedores
              <i className="ri-hand-coin-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}